import { Injectable } from '@angular/core';
import { ContractorProviderService } from '@shared/services/http/http-provider.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractorService {

  constructor(private httpProvider: ContractorProviderService) { }

  public createContractor(body: any){
    return this.httpProvider.sendPostRequest('/create', body, new HttpHeaders, new HttpParams);
  }

  public searchContractor(param: any) {
    return this.httpProvider.sendGetRequest('/search',new HttpHeaders, new HttpParams().set('query', param));
  }

  public updateContractor(id: any, body: any) {
    return this.httpProvider.sendPutRequest(`/update/${id}`, body, new HttpHeaders, new HttpParams);
  }

  public getContractor(param: any) {
    return this.httpProvider.sendGetRequest(`/get/${param}`, new HttpHeaders, new HttpParams);
  }

  public viewContractor() {
    return this.httpProvider.sendGetRequest('/view', new HttpHeaders, new HttpParams);
  }

  public getReports() {
    return this.httpProvider.sendGetRequest(`/service-request/view?query&sort&order&skipCount`, new HttpHeaders, new HttpParams);
  }

  public getContractorReports(id: any) {
    return this.httpProvider.sendGetRequest(`/service-request/view/${id}`, new HttpHeaders, new HttpParams);
  }

  public getPendingTransactionReport(id: any) {
    return this.httpProvider.sendGetRequest(`/service-request/report/${id}`, new HttpHeaders, new HttpParams);
  }
}
